// extracted by mini-css-extract-plugin
export var Avatar = "style-module--Avatar--7ru1V";
export var Contact = "style-module--Contact--CmXEz";
export var ContactDetails = "style-module--ContactDetails--BxXsr";
export var Description = "style-module--Description--LbM5U";
export var Name = "style-module--Name--Dif5w";
export var Profile = "style-module--Profile--8VH78";